(function () {
  if (window.GreatZakkaTypeAwareSearch) return;
  window.GreatZakkaTypeAwareSearch = true;

  var rules = [
    { match: /^shigaraki\s+mugs?$/, query: 'shigaraki product_type:mug' },
    { match: /^kutani\s+plates?$/, query: 'kutani product_type:plate' },
    { match: /^cats?\s+mugs?$/, query: 'cat product_type:mug' },
    { match: /^rinka(?:\s+dinnerware)?$/, query: 'title:Rinka' }
  ];
  var marker = 'gzTypeAwareSearch';
  var forms = document.querySelectorAll('form[action*="/search"]');

  function getRule(value) {
    var normalized = (value || '').trim().replace(/\s+/g, ' ').toLowerCase();
    return rules.find(function (rule) { return rule.match.test(normalized); });
  }

  function restoreOriginalQuery() {
    var params = new URLSearchParams(window.location.search);
    var query = params.get('q') || '';
    var saved;
    try { saved = JSON.parse(sessionStorage.getItem(marker) || 'null'); } catch (e) {}
    if (!saved || saved.query !== query) return;
    forms.forEach(function (form) {
      var input = form.querySelector('input[name="q"]');
      if (input) input.value = saved.original;
    });
    document.title = document.title.replace(/for\s+["“].*?["”]/, 'for "' + saved.original + '"');
    sessionStorage.removeItem(marker);
  }

  function rewriteDirectSearch() {
    if (window.location.pathname !== '/search') return false;
    var params = new URLSearchParams(window.location.search);
    var query = params.get('q') || '';
    if (/\b(?:product_type|title):/i.test(query)) return false;
    var rule = getRule(query);
    if (!rule) return false;
    try { sessionStorage.setItem(marker, JSON.stringify({ original: query, query: rule.query })); } catch (e) {}
    params.set('q', rule.query);
    params.set('type', 'product');
    window.location.replace(window.location.pathname + '?' + params.toString());
    return true;
  }

  restoreOriginalQuery();
  if (rewriteDirectSearch()) return;

  forms.forEach(function (form) {
    form.addEventListener('submit', function () {
      var input = form.querySelector('input[name="q"]');
      if (!input) return;
      var rule = getRule(input.value);
      if (!rule) return;
      try { sessionStorage.setItem(marker, JSON.stringify({ original: input.value, query: rule.query })); } catch (e) {}
      input.value = rule.query;
      var type = form.querySelector('input[name="type"]');
      if (!type) {
        type = document.createElement('input');
        type.type = 'hidden';
        type.name = 'type';
        form.appendChild(type);
      }
      type.value = 'product';
    });
  });
})();